module.exports = __webpack_public_path__ + "static/img/1.a08ed76.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/sp/1.png
// module id = 2FOE
// module chunks = 0